import styled from 'styled-components';

export const TableCard = styled.div`
    background: white;
    border-radius: 12px;
    padding: 16px 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border: 1px solid #e5e7eb;
`;

export const TableTitle = styled.h2`
    font-size: 18px;
    font-weight: 600;
    color: #374151;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
        sans-serif;
    margin: 0;
`;

export const TotalResults = styled.span`
    font-size: 14px;
    color: #6b7280;
    font-weight: 400;
    float: right;
    margin-top: 4px;
`;

export const TableContainer = styled.div`
    width: 100%;
    overflow-x: auto;
`;

export const StyledTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
        sans-serif;
`;

export const TableHeader = styled.th`
    background-color: white;
    padding: 12px 16px;
    font-weight: 500;
    font-size: 14px;
    color: #374151;
    border-bottom: 1px solid rgb(228, 228, 228);
    text-align: left;

    &:last-child {
        text-align: right;
    }
`;

export const TableRow = styled.tr`
    background-color: white;

    &:hover {
        background-color: #f9fafb;
    }
`;

export const TableData = styled.td`
    padding: 12px 16px;
    border-bottom: 1px solid #f3f3f3;
    font-size: 14px;
    color: #374151;
    text-align: left;
    white-space: nowrap;

    &:last-child {
        text-align: right;
    }
`;

export const CommissionValue = styled.span`
    color: #10b981;
    font-weight: 500;
`;

export const PaginationContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px 0 16px;
    margin-top: 16px;
`;

export const PaginationInfo = styled.span`
    font-size: 14px;
    color: #6b7280;
    font-weight: 400;

    @media (max-width: 768px) {
        font-size: 12px;
        text-align: center;
        max-width: 50%;
    }
`;

export const PaginationButtons = styled.div`
    display: flex;
    gap: 8px;

    @media (max-width: 768px) {
        justify-content: space-between;
        align-items: center;
        gap: 4px;
        width: 100%;
    }
`;

export const PageButton = styled.button<{ isActive?: boolean }>`
    padding: 8px 16px;
    border: 1px solid #d1d5db;
    background-color: ${(props) => (props.isActive ? '#f3f4f6' : 'white')};
    color: ${(props) => (props.isActive ? '#374151' : '#6b7280')};
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: ${(props) => (props.isActive ? 'pointer' : 'not-allowed')};
    transition: all 0.2s ease;
    white-space: nowrap;

    &:hover {
        ${(props) =>
            props.isActive &&
            `
            border-color: #9ca3af;
            background-color: #f9fafb;
        `}
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }

    @media (max-width: 768px) {
        padding: 6px 10px;
        font-size: 12px;
    }
`;

export const NoResult = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #040222;
    margin-top: 20px;
`;

export const FilterText = styled.span`
    text-transform: lowercase;
`;

export const TableHead = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgb(228, 228, 228);
    padding: 0 16px 16px 16px;
`;
